import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11 15.414L4.293 8.707l1.414-1.414L11 12.586l5.293-5.293 1.414 1.414z"
});
function SvgAngleDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, _ref);
}
export default SvgAngleDown;